/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Navigation/AngleUp': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M27.94 21.119L16.766 7.855a1.001 1.001 0 0 0-1.53 0L4.06 21.119a.25.25 0 0 0 .029.353l1.146.968a.25.25 0 0 0 .352-.03L16 10.049 26.415 22.41a.248.248 0 0 0 .35.029l1.147-.968a.25.25 0 0 0 .029-.353"/>'
  }
})
